import { Component } from '@angular/core';
import { Order } from '../order/order.model';
import { ViewCartService } from '../view-cart/view-cart.service';
import { SharingDataService } from 'src/sharing-data.service';
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }
  
  constructor(private viewCartService :ViewCartService , private sharingData:SharingDataService) {}
  upiId = 'ranjanaaggarwal79502@oksbi';
  subtotal = 0;
  shipping = 50;
  tax = 100;
  total = this.subtotal + this.shipping + this.tax;
 myOrdersByCustomerId:any;
  customerId:any;
  cartId:number=0;
  cartList:[]=[];
  customerOrdersInCart:any
  myOrders:any;
order:Order={
  cartId:0,
  CustomerId:0,
 status:'',
 paymentStatus:'',
 productPrice:'',
 totalAmount:'',
 orderDate:new Date()


 };

  // qrCodeUrl = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=upi://pay?pa=${this.upiId}&pn=Your%20Store&am=${this.total}&cu=INR`;

  confirmPayment() {
    alert('Thank you! We’ll verify your payment and process your order.');
    this.viewOrdersByCustomerId();
  }

  customerCart:any;
  cartItems:[]=[];
  viewCartByCustomerId(){
      this.customerId=localStorage.getItem('customerId');
      this.viewCartService.viewCartByCustomerId(this.customerId).subscribe({
       next:(response) => {
        this.customerCart=response;
        this.cartItems=this.customerCart;
        console.log('View Cart',  this.customerCart);
       // this.addOrders();
      
      },  
    })
  }

   addOrders(){
     
    let len=this.cartItems.length;
    const orderItems=[]
     for(let i=0;i<len;i++){
         
             this.order.CustomerId=this.customerId;
             console.log(' this.order.CustomerId', this.order.CustomerId);
             this.order.cartId=this.customerCart[i].cartId;
              console.log(' this.order.cartId', this.order.cartId);
             this.order.orderDate=new Date();
             console.log(' this.order.orderDate', this.order.orderDate);
             this.order.paymentStatus='Pending';
              console.log(' this.order.paymentStatus', this.order.paymentStatus);
             this.order.totalAmount=this.customerCart[i].productPrice;
              console.log(' this.order.totalAmount', this.order.totalAmount);
           
              console.log(' this.order.paymentStatus', this.order.paymentStatus);
              this.order.totalAmount=this.customerCart[i].discountedPrice;
             orderItems.push(this.order);
             this.customerCart[i].cartStatus='Ordered';
             this.UpdateCart(this.customerCart[i]);
             
  
     }
     console.log('Order list',orderItems)
     this.sharingData.addOrderFn(orderItems).subscribe({
        next:(response) => {
         this.myOrders=response;
         console.log('Add Cart', response);
      
       },
     })
   }


   
 UpdateCart(selectedOrder:any){
  
  let updateCartItem;
  updateCartItem=selectedOrder
  updateCartItem.cartStatus='Ordered';
  this.sharingData.updateCartFn(updateCartItem).subscribe({
    next:(response) => {
     console.log('Cart updated',response);
     
     this.viewCartByCustomerId();
    }
    });
 }

 updateOrder(selectedOrder:any){
  let updateOrderItem;
  updateOrderItem=selectedOrder
  updateOrderItem.paymentStatus='Paid';
  updateOrderItem.status='Ordered';
  this.sharingData.updateOrderFn(updateOrderItem).subscribe({
    next:(response) => {
     console.log('Order updated',response);
    }
  });
}


viewOrdersByCustomerId(){

  this.customerId=localStorage.getItem('customerId');
  if(this.customerId != null && this.customerId != undefined){
    this.sharingData.getOrderbyCustomerId(this.customerId).subscribe({
       next:(response) => {
        this.myOrdersByCustomerId=response;
        console.log('View Orders by Customer Id', response);
    for(let i=0;i<this.myOrdersByCustomerId.length;i++){
        this.updateOrder(this.myOrdersByCustomerId[i]);
        }

}
    });
  }
}
  }